<script setup>
import { ref } from 'vue'
import Login from './Login.vue'
import Signup from './Signup.vue'
//import Headline from '@/Components/Headline.vue'

const props = defineProps({
    callback: {
        type: [Function, null],
        default: null
    }
})

const emit = defineEmits()

const activeIndex = ref(0)
const tabs = [Login, Signup]

const switchTab = (index) => {
    activeIndex.value = index
}
const onAuth = () => {
    emit('auth')
    if (props.callback) {
        props.callback()
    }
}

</script>


<style lang="scss">
.login-tabs {
    overflow: hidden;
    border-radius: 8px;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    border-radius: 20px;
    background: var(--background-primary);
    &__tab {
        width: 100%;
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 8px;
        border-radius: 20px;
        &.isActive {
            background: var(--background-secondary);
        }
    }
}
</style>

<template>
    <!-- <Headline>
        Вход
    </Headline> -->
    <div class="login-form">
        <div class="login-tabs">
            <button 
                v-for="(text, index) in ['Авторизация', 'Регистрация']"
                class="login-tabs__tab" 
                :class="{isActive: activeIndex === index}"
                @click.prevent="switchTab(index)">
                {{ text }}
            </button>
        </div>
        <component :is="tabs[activeIndex]" @auth="onAuth" />
    </div>
</template>